import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { IBatchEventLog } from 'src/app/models/batch-event-log';
import { IHeaderItem } from 'src/app/models/generic';
import { ILogProcessSale } from 'src/app/models/log-process-sale';
import { ITab } from 'src/app/models/tabs';

@Component({
  selector: 'app-modal-batch-event-log',
  templateUrl: './modal-batch-event-log.component.html',
  styleUrls: ['./modal-batch-event-log.component.scss']
})
export class ModalBatchEventLogComponent implements OnInit {

  public activeTab = 1;
  public logs: IBatchEventLog[] = [];
  public logSap: ILogProcessSale[] = [];
  public sapHeaderList: IHeaderItem[] = [
    { label: "Dt Integração", flexSize: 1 },
    { label: "Dt Process", flexSize: 1 },
    { label: "Cod Venda", flexSize: 1 },
    { label: "Tipo", flexSize: 1 },
    { label: "Cod Process", flexSize: 1 },
    { label: "Sucesso", flexSize: 1 },
    { label: "Erro", flexSize: 1 },
    { label: "RPS", flexSize: 1 },
    { label: "NF", flexSize: 1 },
    { label: "Valor Total", flexSize: 1 },
  ]

  constructor(
    public _dialogRef: MatDialogRef<ModalBatchEventLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {

    this.logs = this.data.Logs;
    this.logSap = this.data.LogSap;

  }

  close(): void {
    let data = null;
    this._dialogRef.close(data);
  }
}
